module.exports = __webpack_public_path__ + "img/xueShan1.afc2a288.png";